export default {
  sections: {
    order_summary: 'Suma zamówienia',
  },
  labels: {
    add_items: 'Dodaj pozycje, aby zacząć',
    item_count_one: '{{count}} pozycja',
    item_count_few: '{{count}} produkty',
    item_count_many: '{{count}} produktów',
    item_count_other: '{{count}} pozycji',
  },
  buttons: {
    return: 'Wróć do przeglądu zamówienia',
  },
};
